import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TopHeader from "../components/TopHeader";
import Calendar from "../components/Calendar";
import Popup from "../components/Popup";
import "../assets/EditRendezvous.scss";
import BackLink from "../components/BackLink";
import InterventionDetails from "../components/InterventionDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentRdv,
  setSelectedSlotR,
  getAvailableSlots,
  fetchRendezvousById,
  updateRendezVous,
} from "../store/slices/rendezVousSlice";
import Recap from "../components/recapPresta";
import useFetchRdv from "../components/useFetchRdv";
import { formatDuration, getMondayOfCurrentWeek } from "../utils/utils";
import Skeleton from "react-loading-skeleton";
import { Helmet, HelmetProvider } from "react-helmet-async";

const OrderSummary = () => {
  const { currentRdv } = useFetchRdv();
  return (
    <>
      {currentRdv?.etablissement ? (
        <Recap
          etablissement={currentRdv?.etablissement}
          prestation={currentRdv?.prestations_snapshot}
        />
      ) : (
        <>
          <Skeleton height={30} width={120} className="mb-2" />
          <Skeleton height={20} width={200} className="mb-1" />
          <Skeleton height={15} width={80} className="mb-3" />
          <hr />
          <Skeleton height={25} width={160} className="mb-3" />
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="d-flex justify-content-between mb-2">
              <Skeleton width={180} height={18} />
              <Skeleton width={60} height={18} />
            </div>
          ))}
          <hr />
          {["Total HT", "TVA prestations", "TVA frais", "Total TTC"].map(
            (_, i) => (
              <div key={i} className="d-flex justify-content-between mb-2">
                <Skeleton width={120} height={18} />
                <Skeleton width={60} height={18} />
              </div>
            )
          )}
          <hr />
          <Skeleton height={25} width={160} className="mb-2" />
          <Skeleton width={120} height={18} />
        </>
      )}
    </>
  );
};

const ServiceDetails = () => {
  const { currentRdv } = useFetchRdv();

  return (
    <>
      {!currentRdv?.prestations_snapshot ? (
        <>
          {Array.from({ length: 2 }).map((_, index) => (
            <div className="row plr-card gray-Bg" key={index}>
              <div className="col-6">
                <div className="pd-bt-8">
                  <Skeleton height={24} width={120} className="mb-2" />
                  <div className="d-flex align-items-center mb-2">
                    <Skeleton height={14} width={30} className="mr-2" />
                    <Skeleton height={14} width={20} className="mx-2" />
                    <Skeleton height={14} width={60} className="mx-2" />
                  </div>
                  <div className="d-flex align-items-center">
                    <Skeleton height={14} width={60} className="mr-2" />
                    <Skeleton height={14} width={20} className="mx-2" />
                    <Skeleton height={14} width={30} className="mx-2" />
                  </div>
                </div>
                <Skeleton height={40} width="100%" className="mt-3" />
              </div>
              <div className="col-6 d-flex flex-column align-items-end justify-content-end">
                <Skeleton height={40} width={40} />
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {currentRdv.prestations_snapshot.map((prestation, index) => (
            <div className="row plr-card gray-Bg" key={index}>
              {/* <div className="col-6"> */}
              <div className="col-12 col-md-6 mb-3 mb-md-0">
                <div className="pd-bt-8">
                  <h4 className="pd-bt-4">{prestation?.name}</h4>
                  <span className="body">
                    {" "}
                    {formatDuration(prestation?.duree)}{" "}
                  </span>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <span className="body">
                    {prestation?.nbr_seances} rendez-vous d'1 heure
                  </span>
                  <img
                    className="separator"
                    src="/images/separateur.svg"
                    alt="separateur"
                  />
                  <span className="body">{prestation?.ttc} €</span>
                </div>
                <div className="body grey66">{prestation?.description}</div>
              </div>
              {/* <div className="col-6 d-flex flex-column align-items-end justify-content-end"> */}
                <div className="col-12 col-md-6 d-flex justify-content-md-end align-items-center">
                {currentRdv?.lieu_intervention === "onsite" ? (
                  <img
                    src="/images/domi.svg"
                    alt="A domicile"
                    className="mr-4"
                  />
                ) : (
                  <img
                    src="/images/professionel.svg"
                    alt="Chez le professionnel"
                  />
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

const EditRendezvous = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPopupVisible, setPopupVisible] = useState(false);
  const currentRdv = useSelector(selectCurrentRdv);
  const [isFetchingSlots, setIsFetchingSlots] = useState(false);
  const { selectedSlotRdv } = useSelector((state) => state.rendezvous);
  const [currentWeekDate, setCurrentWeekDate] = useState(
    getMondayOfCurrentWeek(new Date())
  );
  const { currentRdv: fetchedRdv } = useFetchRdv();
  const { id } = useParams();
  const [calendarTouched, setCalendarTouched] = useState(false);

  const dispatchAvailabilities = (equipe, date = null) => {
    // console.log({ equipe });
    const params = new URLSearchParams();
    fetchedRdv?.prestations_snapshot.forEach((item) => {
      params.append("prestation_ids[]", item.id);
    });
    const mondayDate = getMondayOfCurrentWeek(new Date());

    // Use the explicitly passed date, or the current week date, or fallback to today
    const startDate =
      date?.toISOString().split("T")[0] ||
      currentWeekDate.toISOString().split("T")[0] ||
      getMondayOfCurrentWeek(new Date()).toISOString().split("T")[0];
    // const startDate = date?.toISOString().split("T")[0] || mondayDate.toISOString().split("T")[0]; // Get YYYY-MM-DD format
    const queryString = params.toString();
    // console.log({selectedEmployee})
    dispatch(
      getAvailableSlots(
        `${
          fetchedRdv?.etablissement?.id
        }/available-slots?start_date=${startDate}&${queryString}${
          equipe?.id ? `&equipe_id=${equipe?.id}` : ""
        }`
      )
    );
  };

  // Fetch appointment details if not already loaded
  useEffect(() => {
    if (id && !currentRdv) {
      dispatch(fetchRendezvousById(id));
    }
  }, [id, currentRdv, dispatch]);
  useEffect(() => {
    if (
      fetchedRdv?.etablissement?.id &&
      fetchedRdv?.prestations_snapshot &&
      !isFetchingSlots
    ) {
      setIsFetchingSlots(true);
      const prestationIds =
        fetchedRdv.prestation_ids ||
        fetchedRdv?.prestations_snapshot.map((p) => p.id);
      const params = new URLSearchParams();
      prestationIds.forEach((id) => params.append("prestation_ids[]", id));

      const mondayDate = getMondayOfCurrentWeek(new Date());
      const startDate = mondayDate.toISOString().split("T")[0];
      const queryString = params.toString();

      if (fetchedRdv?.etablissement.id && fetchedRdv?.equipe_id) {
        dispatch(
          getAvailableSlots(
            `${
              fetchedRdv?.etablissement?.id
            }/available-slots?start_date=${startDate}&${queryString}${
              fetchedRdv?.equipe_id ? `&equipe_id=${fetchedRdv?.equipe_id}` : ""
            }`
          )
        )
          .unwrap()
          .finally(() => {
            setIsFetchingSlots(false);
          });
      }
    }
  }, [fetchedRdv?.id, dispatch]);

  const handleEditClick = () => {
    if (
      !currentRdv?.id ||
      !selectedSlotRdv?.slot?.date ||
      !selectedSlotRdv?.slot?.time
    ) {
      console.warn("Données manquantes pour la mise à jour du rendez-vous", {
        currentRdvId: currentRdv?.id,
        selectedSlotDate: selectedSlotRdv?.slot?.date,
        selectedSlotTime: selectedSlotRdv?.slot?.time,
      });
      return;
    }

    const start_time = `${selectedSlotRdv.slot.date} ${selectedSlotRdv.slot.time}:00`;

    const updatedRdv = {
      id: currentRdv.id,
      start_time,
    };
    dispatch(updateRendezVous(updatedRdv))
      .unwrap()
      .then(() => {
        navigate("/compte/rendez-vous/edited/success");
      })
      .catch((error) => {
        // console.error("Erreur lors de la mise à jour du rendez-vous :", error);
      });
  };

  // const handleBackClick = () => {
  //   setPopupVisible(true); // Show popup when clicking back
  // };

  const handlePopupClose = () => {
    setPopupVisible(false); // Close popup without navigating
  };

  const handlePopupQuit = () => {
    setPopupVisible(false);
    navigate(-1); // Navigate back when user confirms quitting
  };

  const formatDateTime = (isoString) => {
    if (!isoString) {
      // console.warn("Invalid or missing isoString:", isoString);
      return { date: "Invalid date", time: "Invalid time" };
    }

    const date = new Date(isoString);
    if (isNaN(date)) {
      // console.warn("Failed to parse isoString:", isoString);
      return { date: "Invalid date", time: "Invalid time" };
    }

    const dateFormatter = new Intl.DateTimeFormat("fr-FR", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    //  timeZone: "Europe/Paris",
    });

    const timeFormatter = new Intl.DateTimeFormat("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    //  timeZone: "Europe/Paris",
    });

    return {
      date: dateFormatter.format(date),
      time: timeFormatter.format(date),
    };
  };

  return (
    <>
         <HelmetProvider>
                                <Helmet>
                                  <title>Page modification rendez-vous </title>
                                  <meta
                                    name="description"
                                    content="modification rendez-vous  "
                                  />
                                </Helmet>
                              </HelmetProvider>
      <TopHeader btn={true} />
      <div className="container mx-auto p-4">
        {/* <BackLink onClick={handleBackClick} /> */}
        <div className="paddingBt-16">
          <button
            className="back-button body text-decoration-none grey-light"
            onClick={(e) => {
              // console.log("calendarTouched:",calendarTouched)
              if (calendarTouched) {
                //  console.log("calendarTouched!!:",calendarTouched)
                setPopupVisible(true);
              } else {
                navigate(-1); // Optionnel : navigation directe si pas de modification
                //  console.log("calendarTouched:",calendarTouched)
              }
            }}
          >
            <img src="/images/arrown-left.svg" alt="Back" />
            Retour
          </button>
        </div>

        <div className="row">
          <div className="col-md-8">
            {fetchedRdv?.prestations_snapshot ? (
              <>
                <div className="calendar-container">
                  <div className="msg-rdv body">
                    Vous êtes en train de déplacer votre rendez-vous de{" "}
                    {formatDateTime(currentRdv?.start_time)?.date} à{" "}
                    {formatDateTime(currentRdv?.start_time)?.time}
                  </div>
                </div>
                <Calendar
                  setCalendarTouched={setCalendarTouched}
                  reduxPrestations={fetchedRdv?.prestations_snapshot}
                  dispatchAvailabilities={(
                    equipe = fetchedRdv?.equipe_id,
                    date
                  ) => {
                    if (date) setCurrentWeekDate(date); // Update the week date when changed
                    dispatchAvailabilities(equipe, date);
                  }}
                  horaires={currentRdv?.etablissement?.horaires}
                  ets={"rdv"}
                  rdvEtablissement={currentRdv?.etablissement}
                />
                <button className="btn-primary w-100" onClick={handleEditClick}>
                  Confirmer la modification
                </button>
              </>
            ) : (
              <>
                <Skeleton height={35} width="100%" className="mb-4" />
                <div className="d-flex justify-content-between mb-3">
                  {Array.from({ length: 7 }).map((_, i) => (
                    <div
                      key={i}
                      className="text-center"
                      style={{ width: "13%" }}
                    >
                      <Skeleton width={50} height={15} className="mb-1" />
                      <Skeleton width={40} height={15} />
                    </div>
                  ))}
                </div>
                {Array.from({ length: 10 }).map((_, rowIdx) => (
                  <div
                    key={rowIdx}
                    className="d-flex justify-content-between mb-2"
                  >
                    {Array.from({ length: 7 }).map((_, colIdx) => (
                      <div key={colIdx} style={{ width: "13%" }}>
                        <Skeleton height={25} />
                      </div>
                    ))}
                  </div>
                ))}
                <div className="mt-4">
                  <Skeleton height={45} width="100%" />
                </div>
              </>
            )}

            <Popup
              isOpen={isPopupVisible}
              onClose={handlePopupClose}
              onAction={handlePopupQuit}
              title="Attention, les modifications ne sont pas enregistrées"
              text="Vous vous apprêtez à quitter la page sans avoir sauvegardé les modifications apportées au rendez-vous, êtes-vous sûr de vouloir continuer ?"
              actionButtonText="Quitter"
              closeButtonText="Rester"
              color="blue"
              icon={
                <svg
                  width="88"
                  height="88"
                  viewBox="0 0 88 88"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="88" height="88" rx="14.6667" fill="#F6E5D6" />
                  <path
                    d="M44.3996 44.4001V34.5001M44.3996 51.7381V51.8251M64.1996 44.4001C64.1996 55.3353 55.3348 64.2001 44.3996 64.2001C33.4644 64.2001 24.5996 55.3353 24.5996 44.4001C24.5996 33.4649 33.4644 24.6001 44.3996 24.6001C55.3348 24.6001 64.1996 33.4649 64.1996 44.4001Z"
                    stroke="#D17E31"
                    strokeWidth="4.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
            />
          </div>
          <div className="col-md-4">
            <OrderSummary />
          </div>

          <div className="col-md-8">
            <h3 className="titleRdv mb-24">Prestation</h3>
            <ServiceDetails />
            <h3 className="titleRdv">Intervention</h3>
            {currentRdv ? (
              <InterventionDetails
                intervention={currentRdv}
                editRdv={"editRdv"}
              />
            ) : (
              <>
                <Skeleton height={24} width={100} className="mb-2" />
                <Skeleton height={50} width="100%" className="mb-3" />
                <Skeleton height={24} width={150} className="mb-2" />
                <Skeleton height={50} width="100%" />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRendezvous;
